export const ConciergeOptions = [
  { id: 'PARK PERMIT', label: 'PARK PERMIT', color: '#009ab6' },
  {
    id: 'TRANSFER RESERVATION',
    label: 'TRANSFER RESERVATION',
    color: '#009ab6',
  },
  {
    id: 'RESTAURANT RESERVATION',
    label: 'RESTAURANT RESERVATION',
    color: '#009ab6',
  },
  {
    id: 'BEACH CLUB RESERVATION',
    label: 'BEACH CLUB RESERVATION',
    color: '#009ab6',
  },
  {
    id: 'CLUB RESERVATION',
    label: 'CLUB RESERVATION',
    color: '#009ab6',
  },
  {
    id: 'ACCOMMODATION',
    label: 'ACCOMMODATION',
    color: '#009ab6',
  },

  {
    id: 'MEDICAL SERVICES',
    label: 'MEDICAL SERVICES',
    color: '#009ab6',
  },
  {
    id: 'CAR & SCOOTER RENTALS',
    label: 'CAR & SCOOTER RENTALS',
    color: '#009ab6',
  },
  {
    id: 'TENDER & WATER TOYS RENTALS',
    label: 'TENDER & WATER TOYS RENTALS',
    color: '#009ab6',
  },

  {
    id: 'TICKETS',
    label: 'TICKETS',
    color: '#009ab6',
  },
  {
    id: 'HELICOPTER & PRIVATE JET',
    label: 'HELICOPTER & PRIVATE JET',
    color: '#009ab6',
  },
  {
    id: 'HABIBI TAKE CARE',
    label: 'HABIBI TAKE CARE',
    color: '#009ab6',
  },
  {
    id: 'SPA RESERVATION',
    label: 'SPA RESERVATION',
    color: '#009ab6',
  },
  {
    id: 'GENERIC SERVICE',
    label: 'GENERIC SERVICE',
    color: '#009ab6',
  },
  {
    id: 'INTERNAL & EXTERNAL CLEANING',
    label: 'INTERNAL & EXTERNAL CLEANING',
    color: '#009ab6',
  },
  {
    id: 'COVID TEST',
    label: 'COVID TEST',
    color: '#009ab6',
  },
  {
    id: 'PARTY & EVENTS',
    label: 'PARTY & EVENTS',
    color: '#009ab6',
  },
  {
    id: 'EXTRA STAFF ON BOARD',
    label: 'EXTRA STAFF ON BOARD',
    color: '#009ab6',
  },
  {
    id: 'TOURS',
    label: 'TOURS',
    color: '#009ab6',
  },
  {
    id: 'SPORT & ACTIVITIES',
    label: 'SPORT & ACTIVITIES',
    color: '#009ab6',
  },
  {
    id: 'LOST & FOUND',
    label: 'LOST & FOUND',
    color: '#009ab6',
  },
  {
    id: 'NIGHT CONCIERGE',
    label: 'NIGHT CONCIERGE',
    color: '#009ab6',
  },
  {
    id: 'DOCK USE',
    label: 'DOCK USE',
    color: '#009ab6',
  },
  {
    id: 'WATER TAXI',
    label: 'WATER TAXI',
    color: '#009ab6',
  },
];

export const PermitType = [
  { label: 'Cruising', id: 'Cruising' },
  { label: 'Diving', id: 'Diving' },
  { label: 'Fishing', id: 'Fishing' },
  { label: 'Other', id: 'Other' },
];

export const PaymentType = [
  {
    id: 'None',
    label: 'None',
  },
  {
    id: 'NAUTICA ASSISTANCE',
    label: 'NAUTICA ASSISTANCE',
  },
  {
    id: 'DIRECTLY (CLIENT)',
    label: 'DIRECTLY (CLIENT)',
  },
];

export const CovidTestType = [
  {
    id: 'PCR',
    label: 'PCR',
  },
  {
    id: 'RAPID',
    label: 'RAPID',
  },
  {
    id: 'OTHER',
    label: 'OTHER',
  },
];

export const CrewGuestType = [
  {
    id: 'CREW',
    label: 'CREW',
  },
  {
    id: 'GUEST',
    label: 'GUEST',
  },
];

export const ModeBeautyType = [
  {
    id: 'ON BOARD',
    label: 'ON BOARD',
  },
  {
    id: 'SALON',
    label: 'SALON',
  },
  {
    id: 'SPA',
    label: 'SPA',
  },
];

export const RequestedServiceBeautyType = [
  {
    id: 'BEAUTY / BEAUTY CARE',
    label: 'BEAUTY / BEAUTY CARE',
  },
  {
    id: 'HAIR',
    label: 'HAIR',
  },
  {
    id: 'MASSAGES & BODY',
    label: 'MASSAGES & BODY',
  },
  {
    id: 'MAKE-UP',
    label: 'MAKE-UP',
  },
  {
    id: 'WELLNESS',
    label: 'WELLNESS',
  },
  {
    id: 'RECOVERY THERAPIES',
    label: 'RECOVERY THERAPIES',
  },
  {
    id: 'INJECTABLE TREATMENTS',
    label: 'INJECTABLE TREATMENTS',
  },
  {
    id: 'REGENERATIVE TREATMENTS',
    label: 'REGENERATIVE TREATMENTS',
  },
  {
    id: 'BODY TREATMENTS',
    label: 'BODY TREATMENTS',
  },
  {
    id: 'SKIN TREATMENTS',
    label: 'SKIN TREATMENTS',
  },
  {
    id: 'HABIBI BESPOKE',
    label: 'HABIBI BESPOKE',
  },
  {
    id: 'E-COMMERCE / SHOP',
    label: 'E-COMMERCE / SHOP',
  },
];

//TODO: restore support for nested categories if backward compatibility is needed
// export const RequestedServiceBeautyTypeTree = [
//   {
//     id: 'BEAUTY_CARE',
//     label: 'BEAUTY / BEAUTY CARE',
//     children: [
//       { id: 'HANDS', label: 'HANDS' },
//       { id: 'FEET', label: 'FEET' },
//       { id: 'WAXING', label: 'WAXING' },
//       { id: 'LASHES & BROWS', label: 'LASHES & BROWS' },
//       { id: 'FACIAL TREATMENTS', label: 'FACIAL TREATMENTS' },
//     ],
//   },
//   {
//     id: 'HAIR',
//     label: 'HAIR',
//     children: [
//       { id: 'HAIR STYLING', label: 'HAIR STYLING' },
//       { id: 'BARBER', label: 'BARBER' },
//     ],
//   },
//   {
//     id: 'MASSAGES_BODY',
//     label: 'MASSAGES & BODY',
//     children: [
//       { id: 'STANDARD MASSAGES', label: 'STANDARD MASSAGES' },
//       { id: 'SPECIAL MASSAGES', label: 'SPECIAL MASSAGES' },
//       { id: 'FACIAL MASSAGE', label: 'FACIAL MASSAGE' },
//       { id: 'BODY TREATMENTS', label: 'BODY TREATMENTS' },
//     ],
//   },
//   {
//     id: 'MAKE-UP',
//     label: 'MAKE-UP',
//     children: [],
//   },
//   {
//     id: 'WELLNESS',
//     label: 'WELLNESS',
//     children: [
//       { id: 'YOGA', label: 'YOGA' },
//       { id: 'PILATES', label: 'PILATES' },
//       { id: 'PERSONAL TRAINER', label: 'PERSONAL TRAINER' },
//     ],
//   },
//   {
//     id: 'RECOVERY_THERAPIES',
//     label: 'RECOVERY THERAPIES',
//     children: [
//       { id: 'OSTEOPATHY', label: 'OSTEOPATHY' },
//       { id: 'PHYSIOTHERAPY', label: 'PHYSIOTHERAPY' },
//     ],
//   },
//   {
//     id: 'INJECTABLE_TREATMENTS',
//     label: 'INJECTABLE TREATMENTS',
//     children: [
//       { id: 'BOTOX (BOTULINUM TOXIN)', label: 'BOTOX (BOTULINUM TOXIN)' },
//       { id: 'FILLERS (HYALURONIC ACID)', label: 'FILLERS (HYALURONIC ACID)' },
//       { id: 'NON-SURGICAL RHINOPLASTY', label: 'NON-SURGICAL RHINOPLASTY' },
//       { id: 'JAWLINE & CHEEK CONTOURING', label: 'JAWLINE & CHEEK CONTOURING' },
//       { id: 'LIP ENHANCEMENT & DEFINITION', label: 'LIP ENHANCEMENT & DEFINITION' },
//       { id: 'TEAR TROUGH TREATMENT', label: 'TEAR TROUGH TREATMENT' },
//       { id: 'BIOSTIMULATION / BIOREVITALIZATION', label: 'BIOSTIMULATION / BIOREVITALIZATION' },
//       { id: 'RADIESSE (CALCIUM HYDROXYAPATITE)', label: 'RADIESSE (CALCIUM HYDROXYAPATITE)' },
//       { id: 'POLY-L-LACTIC ACID', label: 'POLY-L-LACTIC ACID' },
//     ],
//   },
//   {
//     id: 'REGENERATIVE_TREATMENTS',
//     label: 'REGENERATIVE TREATMENTS',
//     children: [
//       { id: 'OZONE THERAPY', label: 'OZONE THERAPY' },
//       { id: 'IV VITAMIN THERAPY', label: 'IV VITAMIN THERAPY' },
//     ],
//   },
//   {
//     id: 'BODY_TREATMENTS_ADVANCED',
//     label: 'BODY TREATMENTS',
//     children: [
//       { id: 'MESOTHERAPY', label: 'MESOTHERAPY' },
//       { id: 'CARBOXYTHERAPY', label: 'CARBOXYTHERAPY' },
//       { id: 'CRYOLIPOLYSIS', label: 'CRYOLIPOLYSIS' },
//       { id: 'RF MICRONEEDLING (MORPHEUS8)', label: 'RF MICRONEEDLING (MORPHEUS8)' },
//     ],
//   },
//   {
//     id: 'SKIN_TREATMENTS',
//     label: 'SKIN TREATMENTS',
//     children: [
//       { id: 'EXOSOME MICRONEEDLING', label: 'EXOSOME MICRONEEDLING' },
//       { id: 'PRX T33', label: 'PRX T33' },
//       { id: 'HYDRAFACIAL', label: 'HYDRAFACIAL' },
//     ],
//   },
//   {
//     id: 'HABIBI_BESPOKE',
//     label: 'HABIBI BESPOKE',
//     children: [
//       { id: 'WEDDINGS', label: 'WEDDINGS' },
//       { id: 'PARTIES', label: 'PARTIES' },
//       { id: 'KIDS PARTIES', label: 'KIDS PARTIES' },
//       { id: 'GROUP BOOKINGS', label: 'GROUP BOOKINGS' },
//       { id: 'RED CARPET', label: 'RED CARPET' },
//       { id: 'BRAND ACTIVATIONS', label: 'BRAND ACTIVATIONS' },
//       { id: 'FASHION SHOW & EDITORIAL', label: 'FASHION SHOW & EDITORIAL' },
//       { id: 'CORPORATE WELLNESS', label: 'CORPORATE WELLNESS' },
//     ],
//   },
//   {
//     id: 'ECOMMERCE_SHOP',
//     label: 'E-COMMERCE / SHOP',
//     children: [
//       { id: 'SKINCARE', label: 'SKINCARE' },
//       { id: 'HAIRCARE', label: 'HAIRCARE' },
//       { id: 'BODY CARE', label: 'BODY CARE' },
//       { id: 'WELLNESS PRODUCTS', label: 'WELLNESS PRODUCTS' },
//       { id: 'HABIBI SELECTION', label: 'HABIBI SELECTION' },
//     ],
//   },
// ];

// export const RequestedServiceBeautyType = RequestedServiceBeautyTypeTree.flatMap((category) => {
//   if (!category.children?.length) {
//     return [
//       {
//         id: category.id,
//         label: category.label,
//         category: category.label,
//       },
//     ];
//   }

//   return category.children.map((item) => ({
//     id: item.id,
//     label: item.label,
//     category: category.label,
//   }));
// });

export const RequestedServiceCleanType = [
  {
    id: 'INTERNAL CLEANING',
    label: 'INTERNAL CLEANING',
  },
  {
    id: 'EXTERNAL CLEANING',
    label: 'EXTERNAL CLEANING',
  },
  {
    id: 'CARPET CLEANING',
    label: 'CARPET CLEANING',
  },
  {
    id: 'MATTRESS CLEANING',
    label: 'MATTRESS CLEANING',
  },
  {
    id: 'SANIFICATION ON BOARD',
    label: 'SANIFICATION ON BOARD',
  },
  {
    id: 'OTHER',
    label: 'OTHER',
  },
];

export const PlaceMedicalType = [
  {
    id: 'STUDIO',
    label: 'STUDIO',
  },
  {
    id: 'ON BOARD',
    label: 'ON BOARD',
  },
  {
    id: 'HOSPITAL',
    label: 'HOSPITAL',
  },
];

export const RequiredVehicleType = [
  {
    id: 'V-CLASS',
    label: 'V-CLASS',
  },
  {
    id: 'S-CLASS',
    label: 'S-CLASS',
  },
  {
    id: 'E-CLASS',
    label: 'E-CLASS',
  },
  {
    id: 'STANDARD',
    label: 'STANDARD',
  },
  {
    id: 'SPRINTER',
    label: 'SPRINTER',
  },
  {
    id: 'SUBURBAN',
    label: 'SUBURBAN',
  },
  {
    id: 'LUGGAGE VAN',
    label: 'LUGGAGE VAN',
  },
  {
    id: 'MAXUS BLACK VAN',
    label: 'MAXUS BLACK VAN',
  },
  {
    id: 'OTHER',
    label: 'OTHER',
  },
];

export const TypeOfServiceRental = [
  {
    id: 'RENTAL CAR',
    label: 'RENTAL CAR',
  },
  {
    id: 'RENTAL SCOOTER',
    label: 'RENTAL SCOOTER',
  },
  {
    id: 'BIKES',
    label: 'BIKES',
  },
  {
    id: 'TENDER',
    label: 'TENDER',
  },
  {
    id: 'WATER TOYS',
    label: 'WATER TOYS',
  },
  {
    id: 'OTHER',
    label: 'OTHER',
  },
];

export const RequestedServiceTicketType = [
  {
    id: 'BY PLANE',
    label: 'BY PLANE',
  },
  {
    id: 'BY FERRY',
    label: 'BY FERRY',
  },
  {
    id: 'BY HELICOPTER',
    label: 'BY HELICOPTER',
  },
  {
    id: 'NOT SPECIFIED',
    label: 'NOT SPECIFIED',
  },
];
